module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-mobile"
  }, [_c('div', {
    staticClass: "header-mobile-content"
  }, [_c('logo', {
    attrs: {
      "type": "night"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "burger",
    on: {
      "click": _vm.toggleBodyClass
    }
  }, [_c('span')])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fdad469e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HeaderBarMobile.vue
// module id = 145
// module chunks = 0